// eslint-disable-next-line no-restricted-imports
import { ListModel, ListResponse } from 'types';
import genericNormalizer from './generic';

export const normalizeList = genericNormalizer<ListResponse, ListModel>(
  ({ from }) => ({
    closed: from('closed'),
    id: from('id'),
    idBoard: from('idBoard'),
    name: from('name'),
    pos: from('pos'),
    subscribed: from('subscribed'),
  }),
);



// WEBPACK FOOTER //
// ./app/gamma/src/api/normalizers/list.ts